<template>
  <div class="pa-5 pb-12">
    <slot />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class LegacyPageContent extends Vue {

}
</script>
